import { onMounted, onUnmounted } from "vue";
import { useIdentityChange } from "../useIdentityChange";
import { useEplexMarkupSettingsStore } from "../../../store/eplex/eplexMarkupSettings";

/**
 * Жизненный цикл наценок на уровне кабинета (CAB-778).
 *
 * Наценки нужны не только разделу «Наценки»: столбцы типов цен в проценке и журнале,
 * цена в корзине — всё читает один стор. Поэтому читаем его один раз при входе,
 * из `MainLayout`, а не из каждого экрана; экраны лишь дожидаются готовности.
 *
 * Смена личности под открытой вкладкой (CAB-734) перечитывает наценки нового
 * человека, а закрытие вкладки досылает правку, которая ещё ждала своей паузы.
 */
export function useMarkupSettingsSync(): void {
  const markupStore = useEplexMarkupSettingsStore();

  const onPageHide = () => {
    markupStore.flushOnUnload();
  };

  useIdentityChange(() => {
    markupStore.reload().catch((error: unknown) => {
      console.error("Markup settings reload error: ", error);
    });
  });

  onMounted(() => {
    markupStore.load().catch((error: unknown) => {
      console.error("Markup settings load error: ", error);
    });
    window.addEventListener("pagehide", onPageHide);
  });

  onUnmounted(() => {
    window.removeEventListener("pagehide", onPageHide);
  });
}
